// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": require("gatsby-module-loader?name=component---node-modules-gatsby-plugin-offline-app-shell-js!/opt/build/repo/node_modules/gatsby-plugin-offline/app-shell.js"),
  "component---src-templates-page-js": require("gatsby-module-loader?name=component---src-templates-page-js!/opt/build/repo/src/templates/page.js"),
  "component---src-pages-bokning-js": require("gatsby-module-loader?name=component---src-pages-bokning-js!/opt/build/repo/src/pages/bokning.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/opt/build/repo/src/pages/404.js"),
  "component---src-pages-index-js": require("gatsby-module-loader?name=component---src-pages-index-js!/opt/build/repo/src/pages/index.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/opt/build/repo/.cache/json/layout-index.json"),
  "offline-plugin-app-shell-fallback.json": require("gatsby-module-loader?name=path---offline-plugin-app-shell-fallback!/opt/build/repo/.cache/json/offline-plugin-app-shell-fallback.json"),
  "priser.json": require("gatsby-module-loader?name=path---priser!/opt/build/repo/.cache/json/priser.json"),
  "kafe.json": require("gatsby-module-loader?name=path---kafe!/opt/build/repo/.cache/json/kafe.json"),
  "rum.json": require("gatsby-module-loader?name=path---rum!/opt/build/repo/.cache/json/rum.json"),
  "bokning.json": require("gatsby-module-loader?name=path---bokning!/opt/build/repo/.cache/json/bokning.json"),
  "hem.json": require("gatsby-module-loader?name=path---hem!/opt/build/repo/.cache/json/hem.json"),
  "hitta-hit.json": require("gatsby-module-loader?name=path---hitta-hit!/opt/build/repo/.cache/json/hitta-hit.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/opt/build/repo/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/opt/build/repo/.cache/json/index.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/opt/build/repo/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-js!/opt/build/repo/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js